module.exports = __webpack_public_path__ + "img/Female_Anterior_PaperDoll.d3b43d6c.png";